import { useEffect, useState } from "react";
import { Menu, X, MapPin } from "lucide-react";
import { BUSINESS } from "../data/products";

const LINKS = [
  { label: "Home", id: "home" },
  { label: "Products", id: "products" },
  { label: "Reviews", id: "reviews" },
  { label: "About", id: "about" },
  { label: "Visit Us", id: "visit" },
  { label: "Contact", id: "contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0a0a0b]/80 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("home")}
          className="font-heading text-lg md:text-xl font-semibold tracking-tight text-white"
        >
          <span className="text-gradient">SMOK CITY</span>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => go(l.id)}
              className="text-sm text-zinc-300 hover:text-white transition-colors duration-200 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </div>

        <a
          data-testid="nav-directions-button"
          href={BUSINESS.mapsLink}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#00e5ff] text-black text-sm font-semibold hover:shadow-[0_0_24px_rgba(0,229,255,0.5)] transition-all duration-300 hover:-translate-y-0.5"
        >
          <MapPin size={16} /> Get Directions
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden backdrop-blur-xl bg-[#0a0a0b]/95 border-b border-white/10 px-6 py-6 flex flex-col gap-4"
        >
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}-link`}
              onClick={() => go(l.id)}
              className="text-left text-zinc-200 hover:text-white py-1 text-base"
            >
              {l.label}
            </button>
          ))}
          <a
            href={BUSINESS.mapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-[#00e5ff] text-black font-semibold"
          >
            <MapPin size={16} /> Get Directions
          </a>
        </div>
      )}
    </nav>
  );
};
